import addUtmParams from '@client-shared/utils/add-utm-params.js'

export default {
  install: (app) => {
    const { $config } = app.config.globalProperties

    app.config.globalProperties.$utm = $config.useUtmParamsForWebsiteLinks
      ? (url, utmContent) => addUtmParams(url, utmContent, $config.utmSource)
      : url => url
  },
}
